export default __webpack_public_path__ + "static/media/0x8d520c8e66091cfd6743fe37fbe3a09505616c4b.b3c13cec.webp";